<!--
 * @Author: your name
 * @Date: 2020-12-10 10:51:07
 * @LastEditTime: 2021-01-21 16:16:27
 * @LastEditors: Please set LastEditors

 * @Description: In User Settings Edit


 * @FilePath: /hsylc2021/src/components/form/ChoiceVolunteerBtn/choiceVolunteerBtn.vue
-->
<template>
  <div class="component-select">
    <div class="component-select-wrap">
      <div class="sybold font16 choiceBtn z2 noevent">{{ text }}</div>
      <el-select
        :value="inputVal"
        class="el-select overlay "
        placeholder="请选择"
        @change="onSelectChange"
        @visible-change="visibleChagneHandler($event)"
        :disabled="disable"
      >
        <el-option class="w-normal" v-for="(item, index) in options" :key="'option_' + index" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
/**
 * 下拉框组件
 * @module Select
 */
export default {
  name: 'Select',
  /**
   * @prop {String} text 按钮文字
   * @prop {String} value 组件数据
   * @prop {Array} options 下拉框数据
   * @prop {Boolena} disable 是否禁用 默认false
   * @prop {Boolena} startVerific 是否开启验证
   * @prop {Boolean} error 是否错误 默认false
   */
  props: {
    text: {
      type: String,
      default: '添加第一志愿'
    },
    // 默认值
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => {
        return [
          {
            value: '选项1',
            label: '黄金糕'
          },
          {
            value: '选项2',
            label: '双皮奶'
          },
          {
            value: '选项3',
            label: '蚵仔煎'
          },
          {
            value: '选项4',
            label: '龙须面'
          },
          {
            value: '选项5',
            label: '北京烤鸭'
          }
        ];
      }
    },
    disable: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    startVerific: {
      type: Boolean,
      default: false
    },
    errmsg: {
      type: String,
      default: '请选择'
    }
  },
  /**
   * @prop {Component} CheckInput 带验证的输入框组件
   */
  components: {},
  /**
   * @prop {Boolean} inputHover 输入框hover状态
   * @prop {Boolean} inputFocs 输入框focus状态
   * @prop {Boolean} selectVisible 选项是否可见
   * @prop {String} inputVal 作为显示的input 的val
   * @prop {String} isOk 选择框报错状态 的val
   */
  data() {
    return {
      inputHover: false,
      inputFocus: false,
      selectVisible: false,
      error: false, // 选择框报错状态
      inputVal: ''
    };
  },
  mounted() {},
  watch: {},
  methods: {
    /**
     * @description 监听 按钮状态 切换背景颜色
     * @function changeEventHandler
     * @param {Object} event 事件对象
     */
    changeEventHandler(event) {
      const that = this;
      let eventType = event.type;
      // console.log('select:', eventType);
      switch (eventType) {
        case 'mouseover':
          if (that.error) return;
          if (that.disable) return;
          that.inputHover = true;
          break;
        case 'mouseout':
          if (that.inputFocus) return;
          if (that.error) return;
          if (that.disable) return;
          // that.inputFocus = false;
          that.inputHover = false;
          break;
        case 'focus':
          if (that.error) return;
          that.focusHandler();
          break;
        case 'blur':
          that.inputFocus = false;
          break;
        default:
          break;
      }
      // this.inputType = result;
    },

    // 下拉框 显示/ 隐藏状态监听
    /**
     * @description 下拉框 显示/ 隐藏状态监听
     * @function visibleChagneHandler
     * @param {String} val 数据
     */
    visibleChagneHandler(val) {
      if (this.error) return;
      this.selectVisible = val;
      if (val) this.inputFocus = true;
      this.$emit('click');
    },
    /**
     * @event input 暴漏input
     * @event change 暴漏change
     */
    /**
     * @description 选项修改
     * @function onSelectChange
     * @param {String} val 数据
     */
    async onSelectChange(val) {
      let label = this.valueToLabel(val);
      this.inputVal = label;
      // v-model 返回 value
      this.$emit('input', String(val));
      // change 返回 label
      this.$emit('change', label.label, label.index);
      if (this.error) return;
      this.inputFocus = val === '' ? false : true;
    },

    /**
     * @description options 通过value 查找label
     * @function valueToLabel
     * @param {String} val
     * @return {String}
     */
    valueToLabel(val) {
      let res = {
        label: '',
        index: ''
      };
      const that = this;
      for (let i = 0; i < that.options.length; i++) {
        const item = that.options[i];
        if (item.value === val) {
          res.label = item.label;
          res.index = i;
          return res;
        }
      }
    }
  }
};
</script>
<style lang="less" src="./choiceVolunteerBtn.less" scoped></style>
<style lang="less">
.el-select-dropdown {
  border-radius: 2px;

  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.05), 0px 1px 2px 1px rgba(0, 0, 0, 0.05) !important;
}
.el-select-dropdown__item {
  color: @color-7C7D80;
  padding-left: 10px !important;
}
.el-select-dropdown__item.hover {
  background-color: @color-FAFAFA;
}
.el-select-dropdown__item.selected {
  color: @color-17181A;
}
</style>
